import { jsx as s } from "react/jsx-runtime";
import { memo as C, forwardRef as M, useMemo as j } from "react";
import { TextField as x } from "./index53.mjs";
import { createNumericFormatComponent as I } from "./createNumericFormatComponent.mjs";
const b = C(
  M(
    ({
      InputProps: r,
      min: o,
      max: t,
      thousandSeparator: m = ",",
      allowLeadingZeros: e = !0,
      decimalScale: p,
      allowNegative: n = !0,
      decimalSeparator: u = ".",
      suffix: f,
      ...i
    }, F) => {
      const c = j(
        () => ({
          inputComponent: I(
            o,
            t,
            m,
            e,
            p,
            n,
            u,
            f
            // biome-ignore lint/suspicious/noExplicitAny:
          ),
          ...r
        }),
        [
          r,
          t,
          o,
          m,
          e,
          p,
          n,
          u,
          f
        ]
      );
      return /* @__PURE__ */ s(x, { ref: F, ...i, InputProps: c });
    }
  )
);
export {
  b as NumericField
};
//# sourceMappingURL=index94.mjs.map
